<div class="content-section" *ngIf="content$ | async as data; else loadingTpl">
  <ng-container *ngIf="data['Conoce-mas-sobre-la-reforma']?.beneficios?.['ajuste-pension'] as ap">
    <p class="intro">{{ ap.intro }}</p>

    <h3>{{ ap.requirementsTitle }}</h3>

    <div class="requirements-grid">
      <article class="requirement-card">
        <icon-ajuste-pension-calendario aria-hidden="true"></icon-ajuste-pension-calendario>
        <p>{{ ap.requirements[0] }}</p>
      </article>

      <article class="requirement-card">
        <icon-ajuste-pension-trending-down aria-hidden="true"></icon-ajuste-pension-trending-down>
        <p>{{ ap.requirements[1] }}</p>
      </article>

      <article class="requirement-card">
        <icon-ajuste-pension-billetera aria-hidden="true"></icon-ajuste-pension-billetera>
        <p>{{ ap.requirements[2] }}</p>
      </article>

      <article class="requirement-card">
        <icon-ajuste-pension-pgu aria-hidden="true"></icon-ajuste-pension-pgu>
        <p>{{ ap.requirements[3] }}</p>
      </article>
    </div>

    <p class="warning" [innerHTML]="ap.warning"></p>

    <div class="request-section">
      <h3>{{ ap.requestTitle }}</h3>
      <p>{{ ap.requestText }}</p>
    </div>

    <div class="channels-grid">
      <article class="channel-card">
        <div>
          <h4>Sitio web</h4>
          <p>Agenda una <button type="button" class="link-inline" (click)="goToVideoAtencion()">Video Atención</button></p>
        </div>
      </article>

      <article class="channel-card">
        <div>
          <h4>Call Center</h4>
          <p>Llámanos al <a href="tel:6006600900">600 6600 900</a></p>
        </div>
      </article>

      <article class="channel-card">
        <div>
          <h4>Sucursales</h4>
          <p>Dirígete a una sucursal o centros de servicio</p>
        </div>
      </article>
    </div>

    <div class="summary-box">
      <h3>{{ ap.summaryTitle }}</h3>
      <p [innerHTML]="ap.summaryText"></p>
    </div>
  </ng-container>
</div>

<ng-template #loadingTpl>
  <app-text-skeleton [lines]="8"></app-text-skeleton>
</ng-template>